import React, { useEffect } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import * as source from "sources/books/fixRouteBids";
import List from "./list";
import Show from "./show";

export default function OrganizationFixRouteBids(props) {
    useEffect(() => {
        return () => props.clearParams("admin-fix-route-bids");
    }, []);

    const { match, location, history } = props;
    const rootUrl = `${match.path}/list`;
    const back = () => history.push(rootUrl);

    return (
        <div className="page-content">
            <Switch location={location}>
                <Route exact path={`${match.path}/`} render={() => <Redirect to={rootUrl} />} />
                <Route
                    exact
                    path={rootUrl}
                    render={() => <List {...props} isTable transition="full" title="Все заявки" nofilter />}
                />
                <Route
                    path={`${rootUrl}/:id`}
                    render={(rest) => (
                        <Show
                            {...rest}
                            transition="full"
                            title="Заявка на корректировку дорожного графа"
                            back={back}
                            source={source}
                        />
                    )}
                />
            </Switch>
        </div>
    );
}
